import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { BucketImage } from '../bucket-image';
import { getImageFileNameCodeFromCurrencyCode, imageDensity, } from '../../atoms';
const ICONS_PATH = 'crypto-icons/v1';
const sizes = {
    xs: 16,
    sm: 20,
    base: 24,
    lg: 32,
    xl: 48,
};
function CurrencyIconComponent({ code: currencyCode, size: sizeName = 'base', density = imageDensity, getBuildEnv, }) {
    const fileNameCode = currencyCode
        ? getImageFileNameCodeFromCurrencyCode(currencyCode)
        : '';
    // e.g. btc-xl_1x.png
    const fileName = `${fileNameCode}-${sizeName}_${density}.png`;
    const fileNameFallback = `placeholder-${sizeName}_${density}.png`;
    const size = sizes[sizeName];
    return (_jsx(BucketImage, { path: `${ICONS_PATH}/${fileName}`, fallbackPath: `${ICONS_PATH}/${fileNameFallback}`, width: size, height: size, responsive: false, bucketInstance: "dev", getBuildEnv: getBuildEnv }));
}
export const CurrencyIcon = memo(CurrencyIconComponent);
